import moment from "moment";
import React from "react";
import styled from "styled-components";
import { ProposalContentType, ProposalFormatType } from "../../../../core";

const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.div`
  min-width: 195px;
`;

const Value = styled.div`
  white-space: pre-wrap;
`;

interface City {
    value: string;
    name: string;
}
interface Intent {
    name: string;
    _id: string;
}


interface FormData {
    city: string;
    microMarkets: string[];
    preferredLocations: string[];
    propertyType: { name: string };
    projectType: { name: string }[];
    minPrice: City;
    maxPrice: City;
    minSeats: number;
    maxSeats: number;
    minArea: string;
    maxArea: string;
    earliestMoveInDate: string;
    lastMoveInDate: string;
    floorPreferences: string[];
    preferedProjects: string[];
    preferredDevelopers: string[];
    constructionStatus: string[];
    facilityType: string;
    Type: string;
    carParking: string;
    powerBackup: string;
    grade: string;
    includeGradeC: boolean;
    includeLeaseExpiry: boolean;
    proposalFormatType: ProposalFormatType;
    proposalContentType: ProposalContentType;
    // certification: string[];
    amenities: string[];
    forecast: number;
    certainity: number;
    weightage: number;
    specialRequirements: string;
    interiorType: string[];
    proposalDueBy: string;
    constructionCompletionDate: string;
    coreRequirements: string[];
    coreRequirementParameters: string[];
    // leaseExpiry: string;
}

const NewRequirementPreview: React.FC<{
    className?: string;
    formData: FormData;
    onClose?: () => void;
    onEdit?: () => void;
    onConfirmation?: () => void;
    approvalButtonDiabled: boolean;
    leadIntent?: Intent
}> = (props) => {
    const { formData } = props;
    const formatfloorPreferences = (array: any) => {
        const sortedFloorPref = array?.slice()?.sort((a: { name: string }, b: { name: string }) => parseInt(a.name, 10) - parseInt(b.name, 10));
        return sortedFloorPref?.map((item: any) => item?.name).join("\n");
    };

    const formatArrayValues = (array: any, formatKey: string = "name") => {
      return array?.map((item: any) => item[formatKey]).join("\n");
    };

    const formatObjectValue = (object: any) => {
        return object?.name;
    };

    return (
        <div className="modal-open">
            <div
                className="detail-poupup bg-white position-fixed top-0 h-100 overflow-auto in"
                style={{ width: "95%" }}
            >
                <div className="container-fluid bg-gray-100 border-bottom py-2 position-sticky top-0 zIndex-99">
                    <div className="row align-items-center px-1">
                        <div
                            className="col-auto"
                            onClick={() => {
                                props.onClose?.();
                            }}
                        >
                            <i className="icon-close text-gray-500 font-xxl cursor-pointer"></i>
                        </div>
                        <div className="col">
                            <h2 className="mb-0 font-lg font-weight-semibold">Summary</h2>
                        </div>
                        <div className="col-auto mt-md-0 mt-1">
                            <span className="bg-white d-inline-block mr-2">
                                <button
                                    onClick={props.onEdit}
                                    className="btn btn-outline-secondary px-4 font-normal font-weight-bold py-2 rounded"
                                >
                                    Edit
                                </button>
                            </span>
                            <button
                                onClick={props.onConfirmation}
                                disabled={props.approvalButtonDiabled}
                                className="btn btn-primary px-3 font-normal font-weight-bold py-2 rounded"
                            >
                                Confirm & Request for Approval
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`${props.className || ""} h-100 `}>
                    <div className="col-12">
                        <div className="pt-4 px-1 pb-5">
                            <PreviewContainer>
                                <Section>
                                    <label className="font-base mb-3 pb-1 font-weight-semibold">
                                        Location Information
                                    </label>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">City:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatObjectValue(formData.city)}
                                        </Value>
                                    </div>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            Preferred Locations:
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatArrayValues(formData.preferredLocations)}
                                        </Value>
                                    </div>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Micro Markets:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatArrayValues(formData.microMarkets)}
                                        </Value>
                                    </div>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Property Type:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatObjectValue(formData.propertyType)}
                                        </Value>
                                    </div>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Project Type:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatArrayValues(formData.projectType)}
                                        </Value>
                                    </div>
                                </Section>

                                <Section>
                                    <label className="font-base pb-1 font-weight-semibold mt-5">
                                        Additional Property Information
                                    </label>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Intent:</Label>
                                        <Value className="py-1 font-weight-semibold">{props?.leadIntent?.name}</Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Seats:</Label>
                                        <Value className="py-1 font-weight-semibold" style={{ whiteSpace: 'nowrap' }}>
                                            {(formData?.minSeats || formData?.maxSeats) ? `${(formData?.minSeats) || 0} - 
                                            ${(formData?.maxSeats) || 0}` : '-'
                                            }
                                        </Value>
                                    </div>
                                    {(formData.propertyType?.name === "Business Center & Co-working Space" ||
                                        formData.projectType?.some((pType: any) => pType.name === "Business Center & Co-working Space")) &&
                                        <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Facility Type:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatObjectValue(formData.facilityType) || '-'}
                                        </Value>
                                    </div>}

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Budget(Per Sq. Ft.):</Label>
                                        <Value className="py-1 font-weight-semibold" style={{ whiteSpace: 'nowrap' }}>
                                            {(formData?.minPrice || formData?.maxPrice) ? `₹ ${(formData?.minPrice?.value ?? formData?.minPrice) || 0} - ₹
                                            ${(formData?.maxPrice?.value ?? formData?.maxPrice) || 0}` : '-'
                                            }
                                        </Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Sq.Ft. Area:</Label>
                                        <Value className="py-1 font-weight-semibold" style={{ whiteSpace: 'nowrap' }}>
                                            {formData?.minArea && formData?.minArea + ` Sq.Ft`} - {formData?.maxArea && formData?.maxArea + ` Sq.Ft`}
                                        </Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            Earliest Move-in Date:
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.earliestMoveInDate ? moment(formData.earliestMoveInDate).format("DD-MM-YYYY") : '-'}
                                        </Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            Last Move-in Date:
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.lastMoveInDate ? moment(formData.lastMoveInDate).format("DD-MM-YYYY") : '-'}
                                        </Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            Floor Preferences:
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {!!formData.floorPreferences?.length ? formatfloorPreferences(formData?.floorPreferences) : '-'}
                                        </Value>
                                    </div>

                                    {/* <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            Preferred Projects:
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {!!formData.preferedProjects?.length ? formatArrayValues(formData?.preferedProjects) : '-'}
                                        </Value>
                                    </div> */}

                                    {/* <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            Preferred Developers:
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {!!formData?.preferredDevelopers?.length ? formatArrayValues(formData.preferredDevelopers) : '-'}
                                        </Value>
                                    </div> */}

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Interior Type:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatArrayValues(formData.interiorType) || '-'}
                                        </Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Include Grade C:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {typeof formData?.includeGradeC === "boolean"
                                                ? formData?.includeGradeC === true
                                                    ? "Yes"
                                                    : formData?.includeGradeC === false && "No"
                                                : "-"}
                                        </Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            <div>Include <span className="d-block">Lease Expiry Options:</span></div>
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {typeof formData?.includeLeaseExpiry === "boolean"
                                                ? formData?.includeLeaseExpiry === true
                                                    ? "Yes"
                                                    : formData?.includeLeaseExpiry === false && "No"
                                                : "-"}
                                        </Value>
                                    </div>

                                    {/* <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Car Parking:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.carParking ? formData?.carParking : '-'}
                                        </Value>
                                    </div>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Power Backup:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.powerBackup ? formData?.powerBackup : '-'}
                                        </Value>
                                    </div> */}

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Construction Status:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatArrayValues(formData?.constructionStatus)}
                                        </Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            <div>Construction <span className="d-block">Completion Date:</span></div>
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.constructionCompletionDate ? moment(formData?.constructionCompletionDate).format("DD-MM-YYYY") : '-'}
                                        </Value>
                                    </div>
                                    {/* <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Grade:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.grade ? formData?.grade : '-'}
                                        </Value>
                                    </div> */}


                                    {/* <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Certification:</Label>
                                        <Value className="py-1 font-weight-semibold">{formatArrayValues(formData.certification)}</Value>
                                    </div> */}

                                    {/* <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Amenities:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {!!formData.amenities?.length ? formatArrayValues(formData.amenities) : '-'}
                                        </Value>
                                    </div> */}

                                    <label className="font-base pb-1 font-weight-semibold mt-5">
                                        Proposal Details
                                    </label>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">
                                            Proposal Due By:
                                        </Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.proposalDueBy ? moment(formData.proposalDueBy).format("DD-MM-YYYY") : '-'}
                                        </Value>
                                    </div>

                                    {/* <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Proposal Format Type:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.proposalFormatType ? formData?.proposalFormatType : '-'}
                                        </Value>
                                    </div>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Proposal Type:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.proposalContentType ? formData?.proposalContentType : '-'}
                                        </Value>
                                    </div> */}

                                    <label className="font-base pb-1 font-weight-semibold mt-5">
                                        Forecast & Certainity
                                    </label>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Forecast (Amount):</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.forecast ? formData?.forecast : '-'}
                                        </Value>
                                    </div>
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Certainity (%):</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.certainity ? formData?.certainity : '-'}
                                        </Value>
                                    </div>

                                    {/* <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Weight:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData?.weightage ? formData?.weightage : '-'}
                                        </Value>
                                    </div> */}

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Special Requirements:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formData.specialRequirements ? formData.specialRequirements : '-'}
                                        </Value>
                                    </div>
                                    
                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Core Requirements:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatArrayValues(formData.coreRequirements,'label') || '-'}
                                        </Value>
                                    </div>

                                    <div className="border-bottom py-2 font-normal d-flex">
                                        <Label className="py-1 text-muted">Requirement Parameters:</Label>
                                        <Value className="py-1 font-weight-semibold">
                                            {formatArrayValues(formData.coreRequirementParameters,'label') || '-'}
                                        </Value>
                                    </div>
                                </Section>
                            </PreviewContainer>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-backdrop fade show"></div>
        </div>
    );
};

export default NewRequirementPreview;
